// @cyc   加入了stream取消监听的管理

import {
  mapMutations,
  mapState,
  mapActions,
  mapGetters
} from 'vuex'

import {
  getPlatform,
  getRunningEnv
} from '@/frontend-lib/tools/getPlatform'
import {
  GetQueryString
} from '@/frontend-lib/tools/utils'
import APIS from '@/apis'
import stat from '@/frontend-lib/lib/stat/Stat.js'
import {getNewData,timeTransform, getColorType} from '@/lib/fragment.js'
import mbtiRandom1 from '@/assets/img-mbti-random1.jpg'
import mbtiRandom2 from '@/assets/img-mbti-random2.jpg'
export default {
  methods: {
    ...mapMutations([
      'setChannelId',
      'setLOADING',
      'setLOADINGTEXT',
      'setTOASTTEXT',
      'setGLOBALLOCK',
      'setVip',
      'setYxyid',
      'setVipInfo',
      'setShowPopWindowStatus',
      'setAdvertisingConfig',
      'setAdvertisingPlatform',
      'setWeappUrlScheme'
    ]),
    ...mapActions([
      'getChannelMsg',
      'pullUserInfo',
      'getUserKeyFromPlatfrom',
      'getWechatData',
      'receiveCoupon',
      'fetchVipinfo',
      'fecthVipPopWindow',
      'fecthVipGetUrl',
      'fetchAdsense',
      'getAdvertisingCepingConfig',
      'fetchAdvertisingPlatform',
      'getMiniappScheme'
    ]),
    shouquan () {
      // localStorage.setItem('yxlMicroSite', this.$route.path);
      window.location.href = APIS.shouquan + '?callback=' + encodeURIComponent(`${location.origin}${location.pathname}?channelId=${this.channelId}`)
    },
    toTop () {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = document.body.scrollTop = 0 //进入置顶
    },
    getScrollBottom () {
      return document.body.scrollHeight - window.screen.availHeight - document.body.scrollTop
    },
    async getUserInfo (channelId) {
      const that = this
      let userKey = that.$route.query.userKey && that.$route.query.userKey !== 'null' ? that.$route.query.userKey :
                    undefined
      let needAuth = that.$route.path == '/index' ? 1 : undefined

      let userId = that.$route.query.userId
      if (userId) {
        needAuth = 1
        userKey = await this.getUserKeyFromPlatfrom({userId})
      }
      const params = {
        channelId: channelId,
        needAuth,
        sessionKey: that.isWxApp ? that.wxMiniAppSessionKey : undefined,
        appCode: that.isWxApp ? 16 : undefined,
        userKey,
        yxyid: that.yxyid ? that.yxyid : undefined
      }

      return that.pullUserInfo({
        params: params
      }).then((res) => {
        console.info('--- 获取用户信息成功 res.data ---', res.data)
        if (this.isActivity20201111) {
          window.monitor.stat({
            level: 'info',
            error: 'API',
            msg: `查询用户信息`,
            remark: '2020双十一活动用户信息查询',
            href: location.href,
            data: JSON.stringify(res.data),
            params: JSON.stringify(params),
            userKey: that.userInfo.userKey,
            userName: that.userInfo.nickname
          })
        }
        if (that.$route.path == '/index' && res.data.code != 302) {
          that.showPromotion() //重定向后添加拦截窗口
        }
        that.$emit('updateUserInfo',res.data)
        return res
      })
    },
    getVipInfo (channelId, userKey) {
      //头条快手App不需要vip业务
      let isFecthVip = this.RENMINWANG_TYPE || this.TOUTIAOAPP || this.WEIBO_NOTLOGIN || this.isActivity20201111 || this.KUAISHOU_APP
      if (isFecthVip) {
        return
      }
      const that = this
      const params = {
        channelId: channelId,
        userKey: this.userInfo.userKey || this.$route.query.userKey || userKey
      }
      if (that.$route.name === 'testDetail') {
        params.scalePoolId = that.$route.params.testId
        return
      }
      return that.fetchVipinfo({
        params: params
      }).then(res => {
        return res
      })

    },
    initAdCoupon(pageName) {
        // 弹窗浮标只在微信浏览器内使用, 并兼容投放渠道（类型 8）
        if (!this.$platform.isWechat || !(this.channelConfig.channelType && [1, 2, 8].includes(+this.channelConfig.channelType))) {
          return
        }
        let that = this
        // console.log('--- 请求弹窗浮标的页面名称 ---', pageName)
        // 1-首页，2-测评报告页，3-趣味测试结果页
        let pages = {
            'showIndex': 1,
            'report2': 2,
            'newReport': 2,
            'topReport': 2,
            'fun-result': 3,
        }
        let position = pages[pageName]
        // 投放渠道 1-是报告页
        if (this.channelConfig.channelType == 8) {
          position = 1
        }
        let params = {
            channelId: this.channelId,
            position: position
        }
        this.fetchAdsense({
            params: params,
        }).then(res => {
            // console.log('--- fetchAdsense 获取的数据 ---', res.data)
            if (res.data && res.data.length) {
                // showPopWindowStatus 是给会员用的，如果报告页有弹窗也强制开启
                if (pageName != 'showIndex') {
                    that.setShowPopWindowStatus(true)
                }
            }
        })
    },
    getNewData (date, type, inShow) {
      return getNewData(date, type, inShow)
    },
    timeTransform (time, type) {
      return timeTransform(time, type)
    },
    getColorType(type){
      return getColorType(type)
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    getCoupon (type, getParams) {
      return new Promise((resolve, reject) => {
        var params = {
          channelId: this.channelId,
          displayPlace: type,
          sourceName: this.$route.query.sourceName ? this.$route.query.sourceName : ''
        }
        if (getParams) {
          params = Object.assign(params,getParams)
        }
        this.receiveCoupon({
          params: params
        }).then((res) => {
          resolve(res)
        })
      })

    },
    initOtherApp () {
      const that = this
      //在app端接入页面支付完后回调
      let ua = navigator.userAgent
      let goAppList = [
        {
          ua: /(?:PregnancyHelper)/.test(ua),
          apphref: '//app.mama.cn/soft_link/pt',
          channelId: 2049
        },
        {
          ua: /(?:wkcqyixinli)/.test(ua),
          apphref: 'wkcqAppScheme://',
          channelId: 2076
        },
        {
          ua: false,
          apphref: 'IDreamSleep://',
          channelId: 2129
        }
      ]
      let goApp = goAppList.map((item, index) => {
        if (that.channelId == item.channelId) {
          return item
        }
      }).filter(one => !!one)

      if (goApp[0]) {
        if (GetQueryString('payDone') && that.channelId == goApp[0].channelId && !goApp[0].ua && !that.platform.isWechat) {
          if (+this.channelId === 2129) {
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && /^((?!chrome|android).)*safari/i.test(ua) && !sessionStorage.getItem('isIdream')) {
              location.href = goApp[0].apphref
            }
            return
          }
          location.href = goApp[0].apphref
        }
      }
    },
    getVipPopWindow (type) {
      console.log('关闭双十二活动接口vipPopWindow弹窗接口')
    },
    getVipGetUrl (getParams) {
      let params = Object.assign({
        channelId: this.channelId
      }, getParams)
      // 参数 source   1活动首页  2领取红包页 3分销页
      // 参数 channelId
      const that = this
      let host = location.host
      if (this.JUMHOST) {
        this.fecthVipGetUrl({
          params: params
        }).then(res => {
          // console.log(res)
        })
      }

    },
    goIntoActivty (type) {
      if (this.HOSTC) {
        location.href = `${location.protocol}//${APIS.shareHostC}${location.pathname}${location.search}#/vipDetail?channelId=${this.channelId}&enterFrom=${type}`
      } else {
        location.href = `${location.protocol}//${APIS.host}${location.pathname}${location.search}#/vipDetail?channelId=${this.channelId}&enterFrom=${type}`
      }
    },
    //跳转新品活动链接
    goIntoDialog (type, config) {
      // 内部渠道
      if (this.CHANNEL_INTERNALCHANNEL) {
        if (type === 'report') {
          this.$router.push({
            name: 'myTests',
            params: { status: 0 },
            query: { channelId: this.channelId }
          })
          return
        }
      }
      let statText = '微站专业测评报告页弹窗'
      if (type == 'logo') {
          statText = '微站浮标'
      } else if (type == 'showIndex') {
          statText = '微站弹窗'
      }
      this.$stat.send({
          name: '公共-交互行为',
          properties: {
              '对象': statText,
              '被点击的元素文字': config.title,
          }
      })
      let href = config.link
      // 替换后台设置的渠道 id
      if (href.includes('${channelId}')) {
          href = href.replace('${channelId}', this.channelId)
      }
      let id = setTimeout(() => {
          clearTimeout(id)
          // console.log('--- 跳转的 href ---', href)
          location.href = href
      }, 350)
    },
    // 投放事件日志
    toufangStat (behavior, message={}) {
      const userId = this.userInfo && this.userInfo.userId || ''
      const channelId = this.channelId
      window.monitor.stat({
        logType: 'stat',
        title: '测评投放-行为日志',
        message: JSON.stringify({
          toufangId: channelId,
          channelName: this.CHANNEL_CHANNELNAME,
          behavior: behavior,
          userId: userId,
          ...message
        }),
        testTitle: '常规',
        url: location.href,
        userId: userId,
        UA: navigator.userAgent
      })
    },
    // 特殊测评类型的投放日志
    toufangStatV1(params) {
      const userId = this.userInfo && this.userInfo.userId || ''
      const channelId = this.channelId
      window.monitor.stat({
        logType: 'stat',
        title: '测评投放-行为日志',
        message: JSON.stringify({
          toufangId: channelId,
          channelName: this.CHANNEL_CHANNELNAME,
          behavior: params.behavior,
          userId: userId,
          ...params.message
        }),
        testTitle: params.testTitle,
        url: location.href,
        userId: userId,
        UA: navigator.userAgent
      })
    },
    isHighPrice360(scalePoolId) {
      return [543, 547, 550, 557].includes(+scalePoolId)
    },

    // 获取先测试后付费测试配置
    getAdvertisingConfig (scalePoolId) {
      if (!this.CHANNEL_NOT_LOGIN) {
        return new Promise((resolve) => {
          resolve()
        })
      }
      if (!scalePoolId) {
        scalePoolId = this.$route.params.testId || (this.scaleModulesMsg ? this.scaleModulesMsg.scalePoolId : this.$route.query.scalePoolId)
      }
      const params = {
        channelId: this.channelId,
        scalePoolId: scalePoolId,
        userKey: this.userKey,
        orderNo: this.$route.query.orderNo,
      }
      return this.getAdvertisingCepingConfig({
        params
      }).then(res => {
        if (res.code === '1') {
          this.setAdvertisingConfig(res.data)
        }else{
          this.setAdvertisingConfig('')
        }
      })
    },

    // 获取投放平台
    getAdvertisingPlatform () {
      if (!this.CHANNEL_NOT_LOGIN) return
      return this.fetchAdvertisingPlatform({
        params: {
          channelId: this.channelId
        }
      }).then(res => {
        if (res.code === '1') {
          this.setAdvertisingPlatform(res.data)
        }
      })
    },

    unlouckToGoDetial(){
      if (this.isIQTest) {
        this.$router.replace({
            name: 'testDetailIQ',
            query: this.$route.query
        })
        return
      }
      this.$router.replace({
          name: 'testDetail',
          params: {
              testId:this.$route.query.scalePoolId
          },
          query: this.$route.query
      })
    },

    fetchTfMiniConfig() {
      return this.$http.get(APIS.getConfigureByCode, {
        params: {
          configureCode: 'ceping-toufang-mini-config'
        }
      }).then(res => {
        const content = JSON.parse(res.data.data.content)
        // let isMiniProgramWorking = content.isMiniProgramWorking
        return content
      })
    },

    toWeapp() {
      this.toufangStat('点击去关注公众号', { testId: this.$route.query.scalePoolId })
      return new Promise((resolve, reject) => {
        // 利用小程序跳转导致小程序被封，改成直接显示二维码图片
        // this.showCodeDialog = true
        // reject()
        // return

        // qrcodePicture 公众号或企微二维码。不存在时停留在h5页面兜底
        if (!this.advertisingConfig || !this.advertisingConfig.qrcodePicture) {
          this.showCodeDialog = true
          reject()
          return
        }
        if (this.weappUrlScheme) {
          location.href = this.weappUrlScheme
          resolve()
          return
        }

        this.fetchTfMiniConfig().then(res => {
          // 配置导流小程序
          if (res.isMiniProgramWorking) {
            let config = this.advertisingConfig
            let url = `${location.origin}${location.pathname}#/wechat-app-qrcode?channelId=${this.channelId}&payRedirectType=${config.payRedirectType}&tfWechatAppQrocde=${config.qrcodePicture}`
            let query = `companyWechatUrl=${encodeURIComponent(url)}`
            // 导企业微信路径
            if (config.payRedirectType == 3) {
              if (window.monitor) {
                window.monitor.stat({
                  logType: 'stat',
                  title: '测评投放-导流小程序',
                  message: JSON.stringify({
                    behavior: '进入企业微信的流程',
                  }),
                  url: location.href,
                  UA: navigator.userAgent
                })
              }
            } else {
              if (window.monitor) {
                window.monitor.stat({
                  logType: 'stat',
                  title: '测评投放-导流小程序',
                  message: JSON.stringify({
                    behavior: '进入公众号的流程',
                  }),
                  url: location.href,
                  UA: navigator.userAgent
                })
              }
            }
            this.getMiniappScheme({
              params: {
                path: 'pages/attention/attention',
                query: query,
              }
            }).then(res => {
              if (res.code === '1' && res.data) {
                this.setWeappUrlScheme(res.data)
                location.href = res.data
                resolve()
              } else {
                if (window.monitor) {
                  window.monitor.stat({
                    logType: 'stat',
                    title: '测评投放-导流小程序',
                    message: JSON.stringify({
                      behavior: '获取小程序地址接口code异常',
                      '投放路径': config.payRedirectType == 3 ? '企业微信' : '公众号',
                      ...res,
                    }),
                    url: location.href,
                    UA: navigator.userAgent
                  })
                }
                this.showCodeDialog = true
                reject()
              }
            }).catch(err => {
              if (window.monitor) {
                window.monitor.stat({
                  logType: 'stat',
                  title: '测评投放-导流小程序',
                  message: JSON.stringify({
                    behavior: '获取小程序地址接口失败',
                    '投放路径': config.payRedirectType == 3 ? '企业微信' : '公众号',
                  }),
                  url: location.href,
                  UA: navigator.userAgent
                })
              }
            })
          } else {
            this.showCodeDialog = true
            reject()
          }
        }).catch(err => {
          this.showCodeDialog = true
          reject()
        })
      })
    },

    // 神策埋点 微站都要 渠道id 和 渠道name
    $wechatTrackPageView(name, properties = {}) {
      if (this.platform.isWechat) {
        this.$trackPageView(name, {
          test_channel_id: this.channelId,
          test_channel_name: this.channelConfig.name ? this.channelConfig.name : '未获取到渠道信息',
          ...properties,
        })
      }
    },
    $wechatTrackEvent(name, properties = {}) {
      if (this.platform.isWechat) {
        this.$trackEvent(name, {
          test_channel_id: this.channelId,
          test_channel_name: this.channelConfig.name ? this.channelConfig.name : '未获取到渠道信息',
          ...properties,
        })
      }
    },
    // 神策埋点 isApp
    $appTrackPageView(name, properties) {
      if (this.isApp) {
        // this.setTOASTTEXT(`APP 神策页面访问-调试-参数: ${JSON.stringify(properties)}`)
        this.$trackPageView(name, properties)
      }
    },
    $appTrackEvent(name, properties) {
      if (this.isApp) {
        // this.setTOASTTEXT(`APP 神策点击事件-调试-参数: ${JSON.stringify(properties)}`)
        this.$trackEvent(name, properties)
      }
    },

    // 神策埋点 渠道来源
    getChannelSource() {
      let r = ''
      if (this.WEIBO_NOTLOGIN) {
        r = '测投'
      } else if (this.platform.isWechat) {
        r = '微站'
      }
      return r
    },
  },
  computed: {
    ...mapState([
      'channelId',
      'channelConfig',
      'wxConfig',
      'yxyid',
      'userInfo',
      'vipInfo',
    ]),
    ...mapGetters([
      'CHANNEL_CHANNELNAME',
      'CHANNEL_INTERNALCHANNEL',
      'CHANNEL_CHANNELTYPE',
      'CHANNEL_NOT_LOGIN',
      'isVip',
      'advertisingConfig',
      'advertisingPlatform',
      'timingData',
      'weappUrlScheme'
    ]),
    $stat(){
      let fakeStat = {
        send:function(params){
          return ''
        }
      }
      if (this.channelConfig && this.channelConfig.channelType && this.channelConfig.channelType == 8) {
        return fakeStat
      }else{
        return new stat()
      }
    },
    platform () {
      return getPlatform()
    },
    $platform(){
      return this.platform
    },
    $runningEnv(){
      return getRunningEnv()
    },
    isApp() {
      const { isYixinliApp, isCeShiApp } = this.$platform
      return isYixinliApp || isCeShiApp
    },
    userKey () {
      return this.$route.query.userKey && this.$route.query.userKey !== 'null' ? this.$route.query.userKey :
             this.userInfo.userKey ? this.userInfo.userKey : ''
    },

    // 是否是测评VIP 0=禁止，1=正常，2=过期
    isCpVip() {
      return this.vipInfo.status === 1
    },

    // 是否是新vip
    isNewVip() {
      return this.isCpVip && !this.isOldVip
    },

    // 是否是老vip
    isOldVip() {
      return [0, 1, 2, 3, 4].includes(this.vipInfo.vipIdentity) && this.vipInfo.status === 1
    },

    // 报告页下载报告为图片按钮显隐
    reportDownloadVisible() {
      // return ((this.isNewVip || this.vipInfo.status === 2 || !this.vipInfo.status) && !this.isHideVipEntrance) || this.isHpnk
       // 3.0会员及以上才有下载报告权益
      return (this.isCpVip && (this.vipInfo.vipIdentity >= 3) && !this.isHideVipEntrance) || this.isHpnk
    },

    CHANNELNAME () {
      return this.CHANNEL_CHANNELNAME
    },
    TESTCHANNEL () {
      // 小楼老师心理课的vip通道下掉
      if (!this.vipInfo.vipChannelStatus) {
        return false
      }
      let exChannel = [170,2437,3583]
      return !exChannel.includes(this.channelId)
    },
    ACTIVTYSHARE () {
      return false
    },
    ACTIVTYSCOUPON () {
      return false
    },
    JUMHOST () {
      const that = this
      let host = location.host
      console.log('跳转域名')
      if (this.HOSTC) {
        return false
      }
      if (host.indexOf(`static${APIS.env}.xinli001.com`) > -1 && APIS.env == '-qc5') {
        return true
      }
      if (host.indexOf(`cp${APIS.env}.japgb7.top`) > -1) {
        return true
      } else {
        return false
      }
    },
    _setshowProps () {
      if (this.$route.name == 'showIndex' || this.$route.name == 'myTests' || this.$route.name == 'sorts' || this.$route.name == 'testDetail') {
        let beginData = new Date('2020/06/25 00:00').getTime()
        let newData = new Date().getTime()
        return  parseInt(newData) > parseInt(beginData)
      }
      return false
    },
    ACTIVTYSLASTYPE () {
      return 0
    },
    HOSTC () {
      let host = location.host
      return host.indexOf(`hd${APIS.env}.xinli001.site`) > -1
    },
    HIDDEN_DETAILS () {
      return this.channelId == 2218 && this.$route.name == 'testDetail'
    },
    baidu_toufang_shenhe(){
      return this.channelId == 3064 && this.$route.name == 'toufangDetail'
    },
    baidu_toufang__footer_shenhe(){
      return this.channelId == 3064 && this.$route.name == 'noLoginCenter'
    },
    HIDDEN_DETAILS_PRICE () {
      let arr = [2259, 2225, 2220, 2129, 2115, 1484, 1777]
      return arr.includes(this.channelId)
    },
    RENMINWANG_TYPE () {
      return this.channelId == 2278 || this.channelId == 2310
    },
    CLOSED_RECOMMON () {
      if (this.channelId == 2325 || this.RENMINWANG_TYPE) {
        return true
      } else {
        return false
      }
    },
    KUAISHOU_APP(){
       return [2939,3268].includes(Number(this.channelId))
    },
    //头条小程序
    TOUTIAOAPP () {
        return [2345, 2293, 2545].includes(Number(this.channelId))
    },
    TOUTIAOAPP_IOS(){
      let query = this.$route.query
      if ([2345, 2545].includes(Number(this.channelId))) {
        return true
      }else if(this.channelId == 2293){
        if (query.isNew && query.isNew == 1) {
          return true
        }else if(query.fromAd && query.fromAd == 1){
          return true
        }else{
          return false
        }

      }else{
        return false
      }
    },
    notLoginToCikeChannelData() {
      const judgeMap = {
        3063: [810],
        3064: [810],
        3097: [810],
      }
      return judgeMap
    },
    isNotLoginToCike() {
      let r = false
      let specifiedScalePoolId = {
        3063: [810],
        3064: [810],
      }
      let notLoginChannelId = [
        2819, 2352, 2335, 2129,
        2611,
        2620, 2621,
        2378, 2379, 2644,
        2553,
        2296,
      ]
      let isSpecifiedId = this.scalePoolId && specifiedScalePoolId[+this.channelId] && specifiedScalePoolId[+this.channelId].includes(+this.scalePoolId)
      let isNotLoginChannel = notLoginChannelId.includes(+this.channelId)
      // || this.isTfWechat 暂时不导此刻
      // if (isSpecifiedId || isNotLoginChannel) {
      if (isSpecifiedId || isNotLoginChannel || this.isTfGuideCk) {
        r = true
      }
      return r
    },
    afterTestPayChannldData(){
      const judgeMap = {
        2493: [608, 609, 613],
        2685: [608, 613, 541, 795, 801, 803,820],
        3026: [613, 541, 795, 608, 801, 803],
        3027: [353, 795, 801, 803, 820],
        3029: [795, 801, 803],
        3030: [795, 801, 803, 806],
        3031: [795, 801, 803, 806],
        3032: [795, 801, 803, 806],
        3051: [801, 803],
        3052: [801, 803, 806],
        3063: [806, 810, 814],
        3064: [806, 810],
        3072: [806],
        3071: [806],
        3070: [806],
        3078: [806],
        3082: [806],
        3073: [806],
        3074: [806],
        3083: [806],
        3084: [806],
        3085: [806],
        3086: [806],
        3097: [353, 806, 810],
        3100: [806],
        3098: [806],
        3099: [806],
        3132: [806,820],
      }
      return judgeMap
    },
    //先测试后付费渠道和测试id集合
    isAfterTestPay(){
      const judgeMap = this.afterTestPayChannldData
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      return this.scalePoolId && judgeMap[this.channelId] && judgeMap[this.channelId].includes(+scalePoolId) || !!this.advertisingConfig
    },
    afterTestPayChannld(){
      let channelIds = Object.keys(this.afterTestPayChannldData).map((item)=> {
        return Number(item)
      }).filter(one => !!one)
      return channelIds
    },
    // 微博免登、哔哩哔哩、知乎免登录等等免登陆渠道汇总 并不只是微博免登陆
    WEIBO_NOTLOGIN() {
      return Object.keys(this.afterTestPayChannldData).includes(String(this.channelId)) || !!this.advertisingConfig
    },
    // 是否是哔哩哔哩渠道
    isBilibili () {
      return [2685, 3026, 3029, 3030, 3031, 3032, 3070].includes(+this.channelId)
    },
    isZhihu() {
      //知乎投放渠道
      return [3027, 3051, 3052, 3082].includes(+this.channelId)
    },
    isBaidu() {
      // 添加百度投放渠道
      return [3072, 3064,3078].includes(+this.channelId)
    },
    // 抖音头条
    isDouyinTouTiao() {
      return [3073, 3074, 3085, 3086].includes(+this.channelId)
    },
    // WPS
    isWps() {
      return [3097, 3100].includes(+this.channelId)
    },
    // 喜马拉雅
    isXimalaya() {
      return [3098, 3099].includes(+this.channelId)
    },
    isKuaishou() {
      return [3083, 3084].includes(+this.channelId)
    },
    isKuaikan() {
      return [3251].includes(+this.channelId)
    },

    // 唯爱妈妈
    isVimm () {
      return [3295].includes(+this.channelId)
    },

    // 唯品会
    isVph() {
      return [3081].includes(+this.channelId)
    },

    // 是否是B端
    isToB () {
      return this.channelConfig && [13, 14, 15, 17].includes(+this.channelConfig.channelType)
    },

    // 飞书
    isFeiShu() {
      return [3321].includes(+this.channelId)
    },

    isWoniu() {
      return [2129].includes(+this.channelId)
    },

    // 麦田心灵
    isMtxl() {
      return [3583].includes(+this.channelId)
    },

    isCkxl() {
      return [3593].includes(+this.channelId)
    },

    // 腾讯成长守护平台
    isTxcz() {
      return [3747].includes(+this.channelId)
    },

    // 测评推广渠道
    isCptg() {
      return [3823].includes(+this.channelId)
    },

    // 此刻心理趣味测试
    isCkxlqwcs() {
      return [3925].includes(+this.channelId)
    },

    // 华为日历
    isHwrl() {
      return [3803].includes(+this.channelId)
    },

    // 浙江健康导航
    isZjjk() {
      return [4280].includes(+this.channelId)
    },

    // 海普诺凯
    isHpnk() {
      return [4411].includes(+this.channelId)
    },
    // 测评小程序渠道
    isCpWxapp() {
      return this.isMiniapp || [4297].includes(+this.channelId)
    },
    // 是否是视频号
    isSHIPINHAO() {
      if (this.advertisingConfig && this.advertisingConfig.advertisingPlatformId === 5) {
        return true
      }
      return false
    },
    // 投放且在微信环境，视频号虽在微信环境，但走投放流程
    isTfWechat() {
      return this.WEIBO_NOTLOGIN && this.platform.isWechat
    },

    // 小程序ios环境
    isIosWxapp() {
      return this.isCpWxapp && this.isIos
    },

    // 在报告页支付
    isPayOnReport () {
      return false
    },

    // B端新菜单
    isToBNewMenu() {
      return this.channelConfig.menuVersion === 2
    },

    // B端高校版答完题跳转提示页，不给看报告
    isGoFinishTips () {
      if (this.isToBNewMenu) return false
      return this.channelConfig.isViewReport === 0
    },
    // 隐藏弹窗与浮标的渠道
    isHideChannel () {
      return [1342, 1479, 1564, 2001, 1415, 1384, 1565, 1424, 1958, 2246, 1563, 1944, 1472, 1968, 1707, 1608, 1566, 2447, 2253, 1671, 2346, 2214, 2101, 2027, 2168, 1987, 2993].includes(+this.channelId)
    },

    // 隐藏会员入口
    isHideVipEntrance() {
      return [3783, 3784, 3792, 3793, 3823, 3932, 4247, 4411, 2018, 1703].includes(+this.channelId) || this.channelConfig.channelType === 4 || this.channelConfig.showVip === 0
    },

    //内部渠道分享文案
    INTERNALCHANNEL_SHARE(){
      return{
        title:'专业、有趣、好玩的壹心理测评，用心理学探索未知自己',
        imgUrl:'https://ossimg.xinli001.com/20200309/9c00bc9481c1ddf25fddcc94f2f451ae.png',
        desc:'壹心理测评，点击开始测试'
      }
    },
    SHWO_VIP_TIS(){
      let exChannel = [1342,1479,1564,1384,2001,1565,1415,1424,1958,1563,1472,1944,1608,1707,2246,1566,1968,1671,2101,2027,2253,2214,2346,2168,1987,2447,2437]
      return !exChannel.includes(this.channelId)
    },
    XIAOXIYE(){
      let exChannel = [1342,1479,1564,1384,2001,1565,1415,1424,1958,1563,1472,1944,1608,1707,2246,1566,1968,1671,2101,2027,2253,2214,2346,2168,1987,2447]
      return exChannel.includes(Number(this.channelId))
    },
    isActivity20201111() {
      let r = false
      let scalePoolId = this.$route.params.testId
      if (!scalePoolId) {
        scalePoolId = this.scaleModulesMsg ? this.scaleModulesMsg.scalePoolId : this.$route.query.scalePoolId
      }
      let activityPage = this.$route.name == '20inPromotion'
      let activityScalePoolIds = [758, 761, 759, 760, 762, 767, 763, 765, 764, 766]
      r = activityScalePoolIds.includes(Number(scalePoolId)) || activityPage
      // r = true
      // console.log('--- 是否是双十一活动 ---', r)
      return r
    },
    IS_APP_MEMBER(){
      //壹心理app与m站渠道 暂时判断
      return [513, 514].includes(+this.channelId)
    },
    IS_WECHAT_CHANNELTYPE() {
        return this.channelConfig.channelType == 1 || this.channelConfig.channelType == 2
    },
    // 内部微站渠道
    isInternalWechat() {
      return this.CHANNEL_INTERNALCHANNEL && this.IS_WECHAT_CHANNELTYPE
    },
    IS_SHOW_MEMBER_SHARE(){
      let host = location.host
      return !(host.indexOf(`hd${APIS.env}.xinli001wx.com`) > -1)
    },
    // 隐藏评论模块的渠道类型
    hideCommentChannelType () {
      return [3, 10, 16].includes(+this.channelConfig.channelType)
    },

    // 2021 525活动时间
    is2021525() {
      return false
    },

    // 内隐自尊
    isImplicit() {
      let scalePoolId = this.$route.params.testId ? this.$route.params.testId : this.$route.query.scalePoolId
      let r = scalePoolId == '847' || this.timingData.isCaculateTime
      return r
    },

    isIQTest() {
      const isIQTestChannel = [3370, 3371, 3073].includes(+this.channelId)
      if (this.$route.name === 'testDetailIQ' && isIQTestChannel) return true
      if (this.$route.name === 'testDetail') return false
      let scalePoolId = this.$route.params.testId
      if (!scalePoolId) {
        scalePoolId = this.scaleModulesMsg ? this.scaleModulesMsg.scalePoolId : this.$route.query.scalePoolId
      }
      if (scalePoolId) {
        return [806, 795].includes(+scalePoolId) && isIQTestChannel
      }
      return false
    },

    isIos () {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    },

    isMiniapp() {
      return /miniprogram/i.test(navigator.userAgent)
    },

    // 隐藏导咨询引流信息
    isHideConsult() {
      return [3712, 3618, 3670, 3067, 3802, 3820, 3821].includes(+this.channelId)
    },

    mbtiRandomQrcode() {
      if (Math.ceil((Math.random() * 20))%2) {
        return mbtiRandom1
      }
      return mbtiRandom2
    },

    // 曼陀罗测试
    isDatura() {
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      let r = [1087, 1090].includes(+scalePoolId)
      return r
    },
    isCareer() {
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      let r = [797].includes(+scalePoolId)
      return r
    },
    isNotLoginToYxlZixun() {
      let r = this.WEIBO_NOTLOGIN && this.isDatura
      return r
    },
    isJumpDetailChannels() {
      return [4711, 4710, 4697, 4631, 4634, 4635, 4636, 4570, 4273, 4286]
    },
    // 定制房树人(放置版本)
    isNewHTPScalePoolIds() {
      return [1207]
    },
    isJumpDetailChannelsCommon() {
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      // 投放房树人跳过详情页
      if (this.isNewHTPScalePoolIds.includes(+scalePoolId)) {
        return true
      }
      return false
    },
    // 曼陀罗投放-假题版本（考虑后期可能去除假题，其它地方勿用）
    isNotLoginDaturaForFalseQuestions() {
      const specifiedChannel = [4676, 4675, 4674, 4673]
      const channelId = this.channelId || this.$route.query.channelId
      return this.WEIBO_NOTLOGIN && this.isDatura && specifiedChannel.includes(+channelId)
    },
    isYY_2_1() {
      const isYY_2_1_channels = [4619, 4618, 4690, 4691, 4692]
      const isYY_2_1_scalePoolIds = [1147, 1146, 1145]
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      return this.scalePoolId && isYY_2_1_channels.includes(this.channelId) && isYY_2_1_scalePoolIds.includes(+scalePoolId)
    },
    // 是否mbti多题版本
    isMBTI_MQ(){
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      return +scalePoolId === 1217
    },
    // 是否mbti2选1
    isMBTI_2_1() {
      const isMBTI_2_1scalePoolIds = [1236, 1235, 1217]
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      return scalePoolId && isMBTI_2_1scalePoolIds.includes(+scalePoolId)
    },
    hideBannerAndConsult() {
      const hideChannels = [4621, 3618, 1343, 3711, 2018, 1703]
      return !hideChannels.includes(this.channelId)
    },
    isSoulInWechat() {
      return this.$platform.isWechat && (this.scalePoolId == 876 || this.$route.query.scalePoolId == 876)
    },
    guideToZxszjScalePoolIds() {
      return [1199, 1206]
    },
    isMediaPlatform() {
      return this.advertisingConfig && this.advertisingConfig.isAdvertisingPlatform == 1
    },
    // 定制指定渠道指定评测id，在支付解锁页展示特定支付样式
    // 目前用于定制抑郁测试
    isCustomPayUnlockType() {
      const channels = [3868, 3738, 4403]
      const scalePoolIds = [353]
      let scalePoolId = this.scalePoolId || this.$route.query.scalePoolId
      return scalePoolId && channels.includes(this.channelId) && scalePoolIds.includes(+scalePoolId)
    },
  },

  created () {
    this._stream_ = []
  },
  mounted () {
    this.initOtherApp()
  },
  beforeDestroy () {
    this._stream_.forEach(res => res[0].removeListener(res[1]))
  }
}



// WEBPACK FOOTER //
// ./src/mixins/globalMixin.js